angular.module("ticketco/common").filter("localizeType", function() {
  return function(input) {
    return window.TC_LABELS.ITEM_TYPES_TYPE[input];
  };
});
